import React from "react";
import logger from "logger";

export const ItemsWon = (props) => {
  const items = props.task.taskstatusdetail.itemswon;
  const { label } = props;
  return (
    <>
      <div className="infokey">{label}</div>
      {items &&
        items.map((item) => {
          return (
            <div
              className="infovalue"
              style={{"fontSize": "15px"}}
            >
              {item.itemname} : {item.itemcount}
            </div>
          );
        })}
    </>
  );
};
